// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1rG-n","modal-background":"_1hUjJ","top-container":"gS7mu","title":"XZRrc","close":"_28cC4","description":"fKuFC","avatar":"_1D2z5","button-container":"_2Li3_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/ShareModal.scss
// module id = ./src/components/ShareModal/ShareModal.scss
// module chunks = 5